import { Space } from "antd";
import { formatIsoDate, renderStatus } from "../../../utils/generalUtils";
import ViewingFormButton from "../../Form/ViewingFormButton";

export const fsrConfig = {
  docType: "Faculty Service Record",
  title: "Faculty Service Record",
  description:
    "Submit your Faculty Service Record for approval. Your submission will be reviewed by your selected program chairs and dean.",
  viewingType: "pdf",
  viewingModalWidth: 1000,
  apiConfig: {
    get: "/employee/fsr",
    post: "/employee/addfsr",
  },
  dataMapper: (item, index) => ({
    ...item,
    key: index + 1,

    status: item?.submission?.derived_status || item?.submission?.status,
    remarks: item?.submission?.remarks,
    created_at: item?.created_at,
    submission_id: item?.submission?.id,
  }),
  columns: () => [
    { title: "No.", dataIndex: "key", key: "key", width: 60 },
    {
      title: "Academic Term",
      dataIndex: "academic_term",
      key: "academic_term",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: renderStatus(
        ["pending", "pending - chairs", "pending - dean"],
        ["approved"],
        ["disapproved", "denied"],
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      render: (value) => (value ? value : "—"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, item) => (
        <Space>
          <ViewingFormButton
            contents={item}
            viewingDataConfig={fsrConfig.viewingDataConfig}
            viewingType={fsrConfig.viewingType}
            viewingModalWidth={fsrConfig.viewingModalWidth}
            isIcon={true}
          />
        </Space>
      ),
    },
    {
      title: "Date Submitted",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => formatIsoDate(value),
    },
  ],
  formFields: [
    {
      name: "academic_term",
      label: "Academic Term",
      type: "term-select",
      rules: [{ required: true, message: "This is required" }],
    },
    {
      name: "status_of_appointment",
      label: "Status of Appointment",
      type: "appointment-status-select",
      rules: [{ required: true, message: "This is required" }],
    },
    {
      name: "program_chairs",
      label: "Program Chairs",
      type: "chair-select",
      rules: [{ required: true, message: "This is required" }],
    },
    {
      name: "dean",
      label: "Dean",
      type: "dean-select",
      rules: [{ required: true, message: "This is required" }],
    },
  ],
};
